import type { ContactState, ContactDataState } from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const contactDataState: ContactDataState = {
  data: [],
  error: null,
  count: 0,
  loading: false,
};

export const contactState: ContactState = {
  contacts: contactDataState,
};

export const ContactModule = {
  namespaced: true,
  state: contactState,
  getters,
  actions,
  mutations,
};
